import { createSlice } from '@reduxjs/toolkit'
import { setCookie, getCookie, removeCookie } from '../../utils/cookieUtils'

const initialState = {
  cart: getCookie('cart', true) || [],
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    updateCart: (state, action) => {
      state.cart = action.payload
      setCookie('cart', action.payload)
    },
    addToCart: (state, action) => {
      state.cart.push(action.payload)
      setCookie('cart', state.cart)
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter((item) => item.id !== action.payload.id)
      setCookie('cart', state.cart)
    },
    removeCart: (state) => {
      state.cart = []
      removeCookie('cart')
    },
  },
})

export const { updateCart, addToCart, removeFromCart, removeCart } =
  cartSlice.actions
export default cartSlice.reducer
